import BankForm from "./components/bank-form";
import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React from "react";
const validationSchema = Yup.object({
  name: Yup.string().required("این فیلد الزامی است"),
});

const initialValues = {
  name: "",
  logo: "",
};

const NewBank = ({
  open,
  handleClose,
  refetch,
}: {
  open: boolean;
  handleClose: () => void;
  refetch: () => void;
}) => {
  const { user } = useAuth();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "banks", {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const notifications = useNotifications();

  const formik = useFormik({
    initialValues, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    onSubmit: async (values) => {
      let res;
      values.logo = " 1";
      res = await insertAsync(values);
      console.log("🚀 ~ onSubmit: ~ res:", res);

      if (res.status === true) {
        notifications.show("بانک جدید با موفقیت ثبت شد!", {
          key: "new-bank",
          severity: "success",
          autoHideDuration: 5000,
        });

        refetch();
        handleClose();
      } else {
        notifications.show("خطا در ذخیره سازی!", {
          key: "err-bank",
          severity: "error",
          autoHideDuration: 5000,
        });
      }
      formik.resetForm();
    },
  });

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
        }}
      >
        <DialogTitle>بانک جدید</DialogTitle>
        <DialogContent>
          <BankForm formik={formik} />
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={isPending}
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button color="error" variant="contained" onClick={handleClose}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewBank;
